/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_NewInputs */

const cs_clients_new = /** @type {(inputs: Clients_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový klient`)
};

const en_clients_new = /** @type {(inputs: Clients_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New client`)
};

/**
* | output |
* | --- |
* | "New client" |
*
* @param {Clients_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_new = /** @type {((inputs?: Clients_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_new(inputs)
	return cs_clients_new(inputs)
});